// Most of this was taken from the style sheets in the library, as suggested
// https://github.com/wojtekmaj/react-daterange-picker
// https://github.com/wojtekmaj/react-calendar
import React from "react";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  /* overrides */
  .calendar-icon {
    margin-left: .5rem;
  }

  button.react-daterange-picker__calendar-button.react-daterange-picker__button {
    background-color: transparent;
  }

  .react-daterange-picker__calendar--open {
    top: 100% !important;
    bottom: unset !important;
  }

  .react-daterange-picker__calendar--closed {
    display: none;
  }

  .card-action {
    &.buttons {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 1rem;
      width: 500px;
      border: none;
      padding: 0 2.5rem 1rem;
    }
  }

  /* from library w/ minors changes */
  .react-calendar {
    width: 280px;
    max-width: 100%;
    background: white;
    border: 1px solid #e9e9e9;
    font-family: 'Whitney Book';
    line-height: 1.125em;
    position: fixed;
    z-index: 1000;

    abbr {
      border: none;
      color: #555555;
      cursor: pointer;
      font-family: 'Whitney Book';
      text-decoration: none;
    }

    &--doubleView {
      width: 700px;

      .react-calendar__viewContainer {
        display: flex;
        margin: -0.5em;

        > * {
          width: 50%;
          margin: 0.5em;
        }
      }
    }

    &,
    & *,
    & *:before,
    & *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    button {
      margin: 0;
      border: 0;
      outline: none;

      &:enabled {
        &:hover {
          cursor: pointer;
        }
      }
    }

    &__navigation {
      background: #f8f8f8;
      display: flex;
      height: 44px;

      button {
        min-width: 44px;
        background: none;
        font-family: 'Whitney Book';

        &:disabled {
          background-color: rgb(240, 240, 240);
        }

        &:enabled {
          &:hover,
          &:focus {
            background-color: #e9e9e9;
          }
        }
      }
    }

    &__month-view {
      &__weekdays {
        background: #f8f8f8;
        border-bottom: 1px solid #e9e9e9;
        text-align: center;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 0.75em;

        &__weekday {
          padding: 0.5em;
        }
      }

      &__weekNumbers {
        .react-calendar__tile {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75em;
          font-weight: bold;
        }
      }

      &__days {
        &__day {
          &--neighboringMonth {
            abbr {
              color: #a6a6a6;
            }
          }
        }
      }
    }

    &__year-view,
    &__decade-view,
    &__century-view {
      .react-calendar__tile {
        padding: 2em 0.5em;
      }
    }

    &__tile {
      max-width: 100%;
      padding: 10px 6.6667px;
      background: none;
      text-align: center;
      line-height: 16px;

      &:disabled {
        background-color: rgb(240, 240, 240);
      }

      &:enabled {
        &:hover,
        &:focus {
          background-color: #e9e9e9;
        }
      }

      &--now {
        background: #f1f1f1;
      }

      &--active {
        background: #006c9c;
        abbr {
          color: white;
        }

        &:enabled {
          &:hover,
          &:focus {
            background: #0084bf;
          }
        }
      }
    }

    &--selectRange {
      .react-calendar__tile {
        &--hover {
          background-color: #e9e9e9;
        }
      }
    }
  }
`

export const StyledDiv = styled.div`
  /* from library w/ minors changes */
  .react-daterange-picker {
    color: #555555;
    display: inline-flex;
    font-family: 'Whitney Book';
    position: relative;

    &,
    & *,
    & *:before,
    & *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    &--disabled {
      background-color: rgb(240, 240, 240);
      color: rgb(109, 109, 109);
    }

    &__wrapper {
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
      align-items: center;
      border: thin solid gray;
      padding: .25rem .75rem;
    }

    &__inputGroup {
      @digit-width: 0.54em;
      @dot-width: 0.217em;
      // own padding + inputs padding + digits width + dots width
      min-width: calc(~'(4px * 3) + ' @digit-width * 8 ~' + ' @dot-width * 2);
      height: 100%;
      flex-grow: 1;
      font-family: 'Whitney Numeric Book';
      padding: 0 2px;
      box-sizing: content-box;

      &__divider {
        padding: 1px 0;
        white-space: pre;
      }

      &__input {
        min-width: @digit-width;
        height: 100%;
        position: relative;
        padding: 0 1px;
        border: 0;
        background: none;
        font: inherit;
        box-sizing: content-box;
        -moz-appearance: textfield;
        color: #555555;
        transition: none;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        &:invalid {
          background: fade(red, 10%);
        }

        &--hasLeadingZero {
          margin-left: -@digit-width;
          padding-left: calc(~'1px + ' @digit-width);
        }
      }
    }

    button.react-daterange-picker__calendar-button.react-daterange-picker__button {
      background-color: transparent;
    }

    &__button {
      border: 0;
      background: transparent;
      margin-left: .5rem !important;
      padding: 4px 6px;


      &:enabled {
        cursor: pointer;

        &:hover,
        &:focus {
          .react-daterange-picker__button__icon {
            stroke: rgb(0, 120, 215);
            background: none;
          }
        }
      }

      &:disabled {
        .react-daterange-picker__button__icon {
          stroke: rgb(109, 109, 109);
        }
      }

      svg {
        display: inherit;
        margin-left: .5rem;
      }
    }

    &__calendar {
      width: 350px;
      max-width: 100vw;
      z-index: 1;

      &--closed {
        display: none;
      }

      .react-calendar {
        border-width: thin;
      }
    }
  }
`;
